import styled from 'styled-components';
import {
  screenSize,
  whiteColor,
  inputBorderColor,
  primaryColor,
} from '@app/styles';

type Props = {
  borderRadius?: number;
};
export const SelectContainer = styled.div`
  position: relative;
  margin-top: 5px;
  .munitech-select {
    .munitech__control {
      height: 48px;
      border-width: 2px;
      border-radius: 2px;
      border-color: ${inputBorderColor};
      box-shadow: none;
      transition: background-color 0.2s ease-in-out,
        border-color 0.2s ease-in-out;
        ${({ borderRadius }: Props) => {
          if (borderRadius) {
            return `border-radius:${borderRadius}px;`;
          }
        }}
      @media (${screenSize.tablet}) {
        background-color: #edeff3;
        &:hover {
          cursor: pointer;
          background-color: ${whiteColor};
        }
        &:active {
          background-color: ${whiteColor};
        }
      }
      &.munitech__control--is-focused {
        border-color: ${primaryColor};
        background-color: ${whiteColor};
      }
    }
    .munitech__indicator-separator {
      display: none;
    }
    .munitech__indicators {
      padding: 8px;
    }
    .munitech__clear-indicator {
      display: none;
    }
    .munitech__multi-value {
      font-size: 17px;
    }
   
  }
`;
